// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type GetSessionResponse = (SuccessResponse & {
    status: string
    token: string
}) | FailedResponse

export class GetSessionRequest extends Request {
    private constructor(init?: RequestInit) { super(`${vcBaseUrl}/session`, init) }
    static async init(body: {}, init?: RequestInit) {
        return new GetSessionRequest({
            ...init,
            method: 'POST',
            credentials: 'include',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(body),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<SuccessResponse & { status: string; token: string; }> {
        const response = await fetch(this)
        const data = createResponseObj<GetSessionResponse>(await response.json())
        console.info("Get Session Results:", data)

        switch (data.status) {
            case 'successful': return data
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
